import React, { useContext, useState } from "react";
import ICatalog_ItemUI from "../../../models/ICatalog_ItemUI";
import InventoryActionEnum from "../../../models/InventoryActionEnum";
import OwButton from "../OwButton/OwButton";
import SupplierContext from "../../../contexts/SupplierContext";
import IWarehouse from "../../../models/IWarehouse";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import { OwFnInput } from "../OwFnInput/OwFnInput";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import { OwAcceptCancelActions } from "../OwAcceptCancelActions/OwAcceptCancelActions";
import { OwIconButton } from "../OwIconButton/OwIconButton";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    catalogItem: ICatalog_ItemUI;
    saveFn: (options: {
        catalogItem: ICatalog_ItemUI;
        qtyAdjustment: number;
        adjustmentType: InventoryActionEnum;
        isDetailViewTable?: boolean;
        parentRowIndex?: number;
        selectedWarehouseGuid?: string;
        note?: string;
    }) => void;
    parentRowIndex?: number;
    isDetailViewTable?: boolean;
    warehouses?: IWarehouse[];
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const OwInventoryAdjustment = (props: Props) => {
    const supplierModel = useContext(SupplierContext);

    const activeClassName = "active btn-primary";
    const [qtyAdustment, setQtyAdjustment] = useState(0);
    const [activeBtn, setActiveBtn] = useState<InventoryActionEnum>(InventoryActionEnum.ADD);
    const [selectedWarehouse, setSelectedWarehouse] = useState<IWarehouse | null>(null);
    const [editMode, setEditMode] = useState(false);
    const [note, setNote] = useState("");

    const save = () => {
        if (supplierModel.has_warehouses && !selectedWarehouse) {
            const notification: INotification = {
                message: "please_select_a_warehouse",
                position: NotificationPositionEnum.bc,
                level: NotificationLevelEnum.error,
            };

            props.notifyFn(null, notification);
            return;
        }

        props.saveFn({
            catalogItem: props.catalogItem,
            qtyAdjustment: qtyAdustment,
            adjustmentType: activeBtn,
            isDetailViewTable: props.isDetailViewTable,
            parentRowIndex: props.parentRowIndex,
            selectedWarehouseGuid: selectedWarehouse ? selectedWarehouse.guid : undefined,
            note: note.length ? note : undefined,
        });

        setEditMode(false);
    };

    const cancel = () => {
        setQtyAdjustment(0);
        setEditMode(false);
    };

    const handleChange = (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        switch (name) {
            case "qty_adjustment":
                setQtyAdjustment(Number(value));
                break;

            case "warehouse":
                setSelectedWarehouse(props.warehouses?.find((w: IWarehouse) => w.id === Number(value)) || null);
                break;

            case "note":
                setNote(value);
                break;
        }
    };

    const toggleBtn = (_activeBtn: InventoryActionEnum) => {
        setActiveBtn(_activeBtn);
    };

    return (
        <div className="OwInventoryAdjustment">
            <>
                {!editMode ? (
                    <OwButton
                        centerIconClass={"fas fa-pencil"}
                        className={"btn-primary"}
                        fn={() => {
                            setEditMode(true);
                        }}
                    />
                ) : (
                    <>
                        <div className={"d-flex"}>
                            <OwAcceptCancelActions
                                isEditMode={false}
                                onAcceptClickFn={save}
                                onCancelClickFn={cancel}
                                withLabels={false}
                                className={"me-4"}
                            />
                            {/*<i*/}
                            {/*    className={"fas fa-check pointer text-success me-2"}*/}
                            {/*    onClick={() => {*/}
                            {/*        save();*/}
                            {/*    }}*/}
                            {/*/>*/}

                            {/*<i*/}
                            {/*    className={"fas fa-times pointer text-danger me-4"}*/}
                            {/*    onClick={() => {*/}
                            {/*        cancel();*/}
                            {/*    }}*/}
                            {/*/>*/}

                            <div className="btn-group" role="group" aria-label="Basic example">
                                <OwButton
                                    hoverTitle={"Add To"}
                                    className={activeBtn === InventoryActionEnum.ADD ? activeClassName : ""}
                                    centerIconClass={"fas fa-plus"}
                                    fn={() => {
                                        toggleBtn(InventoryActionEnum.ADD);
                                    }}
                                />

                                <OwButton
                                    hoverTitle={"Subtract From"}
                                    className={activeBtn === InventoryActionEnum.SUBTRACT ? activeClassName : ""}
                                    centerIconClass={"fas fa-minus"}
                                    fn={() => {
                                        toggleBtn(InventoryActionEnum.SUBTRACT);
                                    }}
                                />
                            </div>
                            <div className={"w-4r ms-2"}>
                                <OwFnInput
                                    fn={handleChange}
                                    name={"qty_adjustment"}
                                    value={qtyAdustment}
                                    className={"text-right"}
                                    type={"number"}
                                    min={0}
                                />
                            </div>
                        </div>
                        {supplierModel.has_warehouses ? (
                            <div className={"mt-2"}>
                                <OwSelectOption
                                    fn={handleChange}
                                    titleProp={"name"}
                                    valueProp={"id"}
                                    name={"warehouse"}
                                    options={props.warehouses}
                                />
                            </div>
                        ) : null}
                        <div className="mt-2">
                            <OwLabel title={"note"} />
                            <OwFnInput fn={handleChange} name={"note"} value={note} type={"text"} placeholder={"note"} />
                        </div>
                    </>
                )}
            </>
        </div>
    );
};
